import { snakeToCaps } from '~/helpers/formatting';

export const vendorVerifiedText = name => `${snakeToCaps(name)} update was verified by at least 1 vendor`;

export const notVerifiedText = name => `${snakeToCaps(name)} update was not verified by any vendor`;
